<template>
  <footer class="the-footer flex-shrink-0 justify-right z-30" :class="classes">
    <p class="footer-margin">
      <span class="text-xs md:text-base">COPYRIGHT &copy;</span>
      <span class="text-xs md:text-base"> {{ new Date().getFullYear() }} </span>
      <a href="https://bds3d.com" target="_blank" rel="nofollow">
        <span class="text-xs md:text-base">Beyond Digital Solutions</span>
      </a>
      <span class="hidden sm:inline-block md:text-base">, All rights Reserved - version {{ backend_version }}</span>
    </p>
  </footer>
</template>

<script>
import HealthyService from '@/services/Healthy.service'
export default {
  name: "the-footer",
  data() {
    return {
      backend_version: null,
    }
  },
  props: {
    classes: {
      type: String,
    }
  },
  methods: {
    toVersionString(version) {
      return `${version.major}.${version.minor}.${version.path}`;
    },
    getVersion() {
      HealthyService.getVersion().then((response) => {
        let version = localStorage.getItem('bds-version') || '{}';
        if (version) {
          version = JSON.parse(version);
        }
        let server_version_str = this.toVersionString(response.version);
        let force_reload = localStorage.getItem('bds-force-reload') || '';

        if (response.force_reload && server_version_str !== force_reload) {
          localStorage.removeItem('bds-version');
          localStorage.setItem('bds-force-reload', server_version_str);
          window.location.reload();
          return;
        }

        if (Object.keys(version).length === 0) {
          localStorage.setItem('bds-version', JSON.stringify(response.version));
          window.location.reload();
          return;
        }

        let server_version = response.version;
        if (server_version.major >= version.major && server_version.minor >= version.minor && server_version.path > version.path) {
          localStorage.setItem('bds-version', JSON.stringify(response.version));
          window.location.reload();
          return;
        }

        this.backend_version = `${version.major}.${version.minor}.${version.path}.${process.env.VUE_APP_VERSION}`;
      }, (error) => {
        console.error(error);
        this.backend_version = '0.0.0'
      });
    }
  },
  mounted() {
    this.getVersion();
  }
}
</script>

<style lang="scss">
.justify-right {
  justify-content: flex-end !important;
}

.the-footer {
  position: fixed;
  background: $white;
  bottom: 0;
  width: calc(100%);
  box-shadow: 0 -4px 20px 0 rgba(0, 0, 0, .05);
}

.footer-margin {
  @media screen and (min-width: $screen-xl-min) { //lg
    margin-right: var(--max-sidebar-width);
  }
}


</style>
